import { AssetReferralActionStatusEnum, ProhibitionRequest } from "types";

const CourtSection: React.FC<{
  hasCourtData: boolean;
  referral: any;
  onOpenCourtPopup: () => void;
  onForwardToCoordinator: () => void;
  isEditMode: boolean;
  isEditing: boolean;
  isAssetRegistrar: boolean;
  onEditClick: () => void;
  prohibitionData: ProhibitionRequest;
}> = ({
  hasCourtData,
  referral,
  onOpenCourtPopup,
  onForwardToCoordinator,
  isAssetRegistrar,
  isEditMode,
  isEditing,
  onEditClick,
  prohibitionData,
}) => {
  return (
    <div className="">
      {/* <div className="flex justify-between items-center mb-4">
        <h3 className="text-base font-semibold mb-4">
          Court Information
        </h3>
      </div> */}

      {hasCourtData ? (
        <>
          {/* <CourtDisplay referral={referral} isAssetRegistrar={isAssetRegistrar} isEditMode={isEditMode} isEditing={isEditing}  */}
          {/* onEditClick={onEditClick}/> */}
          {prohibitionData?.forward_status === "Forwarded to Registrar" &&
            isAssetRegistrar &&
            prohibitionData.status ===
              AssetReferralActionStatusEnum.PROHIBITION_REQUEST_APPROVED && (
              <div className="flex justify-end mt-6">
                <button
                  onClick={onForwardToCoordinator}
                  className="bg-black text-white hover:bg-gray-700 px-6 py-2 rounded-lg transition-colors"
                >
                  Forward to Coordinator
                </button>
              </div>
            )}
        </>
      ) : (
        <div className="">
          <button
            onClick={onOpenCourtPopup}
            className="referral-form-button text-white"
            style={{ fontSize: "14px", padding: "10px" }}
          >
            + Add Court Details
          </button>
        </div>
      )}
    </div>
  );
};
export default CourtSection;
